import { createStore } from "vuex";
import auth from "./modules/auth";
import settings from "./modules/settings";
import plan from "./modules/plan";
import reports from "./modules/reports";
import customer from "./modules/customer";
import transaction from "./modules/transaction";
import expenses from "./modules/expenses";
import estimate from "./modules/estimate";
import invoices from "./modules/invoices";

export default createStore({
  modules: {
    auth,
    settings,
    plan,
    reports,
    customer,
    transaction,
    expenses,
    estimate,
    invoices,
  },
});
